import { render, staticRenderFns } from "./SocialRegister.vue?vue&type=template&id=2bba8d0f&"
import script from "./SocialRegister.vue?vue&type=script&lang=js&"
export * from "./SocialRegister.vue?vue&type=script&lang=js&"
import style0 from "./SocialRegister.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports